module.exports = __webpack_public_path__ + "static/img/cytx.2b54c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cytx.png
// module id = VOYz
// module chunks = 37